import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEmployeeCompaniesData() {
    const { data: companiesData, isLoading: isLoadingCompaniesData } = useQuery({
        queryKey: ['employee-companies-data'],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.salary.employees.companies-for-select-data'),
            );
            return data;
        },
        placeholderData: [],
    });

    return {
        companiesData,
        isLoadingCompaniesData,
    };
}
